import React from 'react'
import { Table, Segment, Header, Message } from 'semantic-ui-react'
import { Link } from 'react-router-dom'
import { sortBy } from 'lodash'

const usageTip = `Taulukosta löydät kaikki valvottavat kiinteistösi. Painamalla kohteen kohdalta 
"Avaa valvonta", pääset tarkkailemaan kohteen mittaustietoja.`

const LocationRow = ({ city, address, appId, privateLink }) => (
    <Table.Row>
        <Table.Cell>{city}</Table.Cell>
        <Table.Cell>{address}</Table.Cell>
        <Table.Cell>
            <Link to={`/asiakkaat/${privateLink}/${appId}`}>Avaa valvonta</Link>
        </Table.Cell>
    </Table.Row>
)

const UserLocations = ({ locationsData, privateLink }) => {
    const locationsByCity = sortBy(locationsData, 'city')
    return (
        <Segment size="large">

            <Header as="h3">Listaus kohteista</Header>

            <Message info icon="idea" content={usageTip} />

            <Table striped >

                <Table.Header>
                    <Table.Row>
                        <Table.HeaderCell>Kaupunki</Table.HeaderCell>
                        <Table.HeaderCell>Osoite</Table.HeaderCell>
                        <Table.HeaderCell>Valvonta</Table.HeaderCell>
                    </Table.Row>
                </Table.Header>

                <Table.Body>
                    {locationsByCity.map(l =>
                        <LocationRow
                            key={l.app_id}
                            city={l.city}
                            address={l.address}
                            appId={l.app_id}
                            privateLink={privateLink}
                        />
                    )}
                </Table.Body>

            </Table>

        </Segment>
    )
}

export default UserLocations


// WEBPACK FOOTER //
// ./src/User/UserLocations.js